import CryptoJS from 'crypto-js'

const LinkExtractAvon = (login, catalogId) => {
  if (!login || !catalogId || !process.env.REACT_APP_EXTRACT_URL) {
    return undefined
  }

  let key = CryptoJS.MD5(`${login}AvonLtm`) + ''
  key = key.toUpperCase()
  return `${process.env.REACT_APP_EXTRACT_URL}/avonAuthentication/${catalogId}/extrato/?a=${login}&encryptedKey=${key}`
}

export default LinkExtractAvon



// WEBPACK FOOTER //
// ./src/App/Header/UserProfile/UserProfileSubmenu/LinkExtractAvon.js